// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popupReveal-popup {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;


  color: white;
  font-family: sans-serif;
}


.popupReveal-background {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
}


.popupReveal-background.gradient {
  background: radial-gradient(#042 0%, #021 100%);

  opacity: 0;
  animation: fadein 1s 2.5s;
  animation-fill-mode: forwards;
}

.popupReveal-background.success-gradient {
  background: radial-gradient(#042 0%, #021 100%);

  opacity: 0;
  animation: fadein 1s 1s;
  animation-fill-mode: forwards;
}

.popupReveal-background.failure-gradient {
  background: radial-gradient(#400 0%, #200 100%);

  opacity: 0;
  animation: fadein 1s 1s;
  animation-fill-mode: forwards;
}

.popupReveal-background.black {
  background: black;
  animation: fadein 1s;
  animation-fill-mode: forwards;
}

/*@keyframes fadeinout {
    0% { opacity: 0;}
    50% { opacity: 1;}
    100% { opacity: 1;}
} */

@keyframes fadein {
    0% { opacity: 0;}
    100% { opacity: 1;}
}

/* @keyframes fadein {
    0% { opacity: 0; background: black;}
    50% { opacity: 1; background: radial-gradient(#000 0%, #000 100%);;}
    100% { opacity: 1; background: radial-gradient(#042 0%, #021 100%);}
}
 */



.popupReveal-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.popupReveal-label {
  font-size: 1.5rem;

  opacity: 0;
  animation: fadein 1s 0s;
  animation-fill-mode: forwards;
}

.popupReveal-revealText {
  font-size: 2.5rem;
  margin-bottom: 10vh;

  opacity: 0;
  animation: fadein 1s 2.5s;
  animation-fill-mode: forwards;
}

.popupReveal-missionResult {
  font-size: 2.5rem;
  margin-bottom: 10vh;

  opacity: 0;
  animation: fadein 1s 1s;
  animation-fill-mode: forwards;
}

.popupReveal-roleDescription {
  margin: 0vh 5vw 10vh 5vw;
  text-align: center;

  font-size: 1.1rem;

  opacity: 0;
  animation: fadein 1s 3s;
  animation-fill-mode: forwards;
}

.popupReveal-tapToContinue {
  opacity: 0;
  animation: fadein 1s 3.5s;
  animation-fill-mode: forwards;
}
`, "",{"version":3,"sources":["webpack://./src/style/popupReveal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,aAAa;;;EAGb,YAAY;EACZ,uBAAuB;AACzB;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,aAAa;AACf;;;AAGA;EACE,+CAA+C;;EAE/C,UAAU;EACV,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;;EAE/C,UAAU;EACV,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;;EAE/C,UAAU;EACV,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;;;GAIG;;AAEH;IACI,KAAK,UAAU,CAAC;IAChB,OAAO,UAAU,CAAC;AACtB;;AAEA;;;;;EAKE;;;;AAIF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;;EAEjB,UAAU;EACV,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;;EAEnB,UAAU;EACV,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;;EAEnB,UAAU;EACV,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;;EAElB,iBAAiB;;EAEjB,UAAU;EACV,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,6BAA6B;AAC/B","sourcesContent":[".popupReveal-popup {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  position: absolute;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n\n\n  color: white;\n  font-family: sans-serif;\n}\n\n\n.popupReveal-background {\n  position: absolute;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n}\n\n\n.popupReveal-background.gradient {\n  background: radial-gradient(#042 0%, #021 100%);\n\n  opacity: 0;\n  animation: fadein 1s 2.5s;\n  animation-fill-mode: forwards;\n}\n\n.popupReveal-background.success-gradient {\n  background: radial-gradient(#042 0%, #021 100%);\n\n  opacity: 0;\n  animation: fadein 1s 1s;\n  animation-fill-mode: forwards;\n}\n\n.popupReveal-background.failure-gradient {\n  background: radial-gradient(#400 0%, #200 100%);\n\n  opacity: 0;\n  animation: fadein 1s 1s;\n  animation-fill-mode: forwards;\n}\n\n.popupReveal-background.black {\n  background: black;\n  animation: fadein 1s;\n  animation-fill-mode: forwards;\n}\n\n/*@keyframes fadeinout {\n    0% { opacity: 0;}\n    50% { opacity: 1;}\n    100% { opacity: 1;}\n} */\n\n@keyframes fadein {\n    0% { opacity: 0;}\n    100% { opacity: 1;}\n}\n\n/* @keyframes fadein {\n    0% { opacity: 0; background: black;}\n    50% { opacity: 1; background: radial-gradient(#000 0%, #000 100%);;}\n    100% { opacity: 1; background: radial-gradient(#042 0%, #021 100%);}\n}\n */\n\n\n\n.popupReveal-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.popupReveal-label {\n  font-size: 1.5rem;\n\n  opacity: 0;\n  animation: fadein 1s 0s;\n  animation-fill-mode: forwards;\n}\n\n.popupReveal-revealText {\n  font-size: 2.5rem;\n  margin-bottom: 10vh;\n\n  opacity: 0;\n  animation: fadein 1s 2.5s;\n  animation-fill-mode: forwards;\n}\n\n.popupReveal-missionResult {\n  font-size: 2.5rem;\n  margin-bottom: 10vh;\n\n  opacity: 0;\n  animation: fadein 1s 1s;\n  animation-fill-mode: forwards;\n}\n\n.popupReveal-roleDescription {\n  margin: 0vh 5vw 10vh 5vw;\n  text-align: center;\n\n  font-size: 1.1rem;\n\n  opacity: 0;\n  animation: fadein 1s 3s;\n  animation-fill-mode: forwards;\n}\n\n.popupReveal-tapToContinue {\n  opacity: 0;\n  animation: fadein 1s 3.5s;\n  animation-fill-mode: forwards;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
